import React from 'react';
import { Tooltip, TooltipProps } from '@mantine/core';

export function ETooltip({ ...props }: TooltipProps) {
    return (
        <Tooltip
            position="bottom"
            withArrow
            arrowSize={10}
            arrowOffset={10}
            arrowPosition="center"
            {...props}
        />
    )
}
